import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostShippingLabelsPrintParams } from '~/types/delivery-agency.types';

const usePostShippingLabelsPrint = () => {
  const { runDownloadAsync } = useAsyncHandler();

  const postShippingLabelsPrint = useAPI<TypePostShippingLabelsPrintParams>({
    endpoint: API_ENDPOINT.DELIVERY_AGENCY.POST_SHIPPING_LABELS_PRINT,
    method: 'post',
    responseType: 'blob',
  });

  const requestShippingLabelsPrint = async (
    params: TypePostShippingLabelsPrintParams,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: () => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) => {
    runDownloadAsync(() => postShippingLabelsPrint({ params }), {
      onSuccess,
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { requestShippingLabelsPrint };
};

export default usePostShippingLabelsPrint;
